import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './views';
import * as serviceWorker from './serviceWorker';
import 'sanitize.css';
import 'sanitize.css/forms.css';
import 'sanitize.css/typography.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

serviceWorker.unregister();
